import { createTheme, ThemeOptions, ThemeProvider } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles';
import React, { useState } from 'react';
import Poppins from '../Fonts/Poppins-Regular.ttf';
import Raleway from '../Fonts/Raleway-VariableFont_wght.ttf';
import Manrope from '../Fonts/Manrope-VariableFont_wght.ttf';
import PoppinsThin from '../Fonts/Poppins-thin.ttf';
import RalewayMedium from '../Fonts/raleway-medium.ttf';
import RalewayThin from '../Fonts/raleway-thin.ttf';
import Ralewaysemi from '../Fonts/raleway-semi.ttf';
import ManropeBold from '../Fonts/manrope-bold.ttf';
import Poppins700 from '../Fonts/Poppins700.ttf';
import Poppins800 from '../Fonts/Poppins800.ttf';


import { themeCreator } from './base';

export const themes = createTheme({
  palette: {
    primary: {
      main: '#120242'
    },
    secondary:{
      main:'#120242'
    },
    error:{
      main:'#F45252'
    },
    info:{
        main:'#F4A952'
    }
  },
  shape: {
    borderRadius: 12
  },
  components: {
    // Name of the component
    MuiDialog: {
      styleOverrides: {
        root: {
          borderRadius: '50px'
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          border: 0
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: '0px'
        },
        underline: {
          ':before': {
            borderBottom: 'none'
          },
          '::after':{
            borderBottom:'none'
          },
          ':after':{
            borderBottom:0
          },
         
        
        },
        input:{
          fontFamily:'Raleway',
          fontSize: '14px',
          background:'#F4F5F4',
          
          
          
        }
      }
    },
    MuiInputLabel:{
      
      styleOverrides:{
        root:{
          fontFamily:'Raleway',
          fontSize: '14px',
          color:' #737B7D',
          fontWeight:400
         
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          fontWeight: 700,
          fontSize: '12px',
          letterSpacing: '0.2px',
          color: 'rgba(0, 0, 0, 0.5)',
          margin: 0,
          fontFamily:'Raleway',
          lineHeight:'12px'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 700,
          letterSpacing: '0.3px',
          textTransform: 'none',
          paddingTop: '13px',
          paddingBottom: '13px',
          borderRadius: '4px',
          fontFamily: 'RalewaySemi'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          letterSpacing: 0.2,
          lineHeight: '30px',
          fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            'Poppines',
            'Raleway'
          ].join(',')
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Poppins';
          src:url(${Poppins});
        }
        @font-face {
          font-family: 'Raleway';
          src:url(${Raleway});
        }
        @font-face {
          font-family: 'Manrope';
          src:url(${Manrope});
        }
        @font-face {
          font-family: 'PoppinsThin';
          src:url(${PoppinsThin});
        }
        @font-face {
          font-family: 'RalewayMedium';
          src:url(${RalewayMedium});
        }
        @font-face {
          font-family: 'RalewayThin';
          src:url(${RalewayThin});
        }
        @font-face {
          font-family: 'RalewaySemi';
          src:url(${Ralewaysemi});
        }
        @font-face {
          font-family: 'Poppins700';
          src:url(${Poppins700});
        }
        @font-face {
          font-family: 'Poppins800';
          src:url(${Poppins800});
        }
        Poppins700
        @font-face {
          font-family: 'ManropeBold';
          src:url(${ManropeBold});
        }`
    },
    MuiAlert:{
      styleOverrides: {
        standardSuccess: {
          background:'rgba(37, 211, 177, 0.2)',
          color: '#25D3B1',
          borderRadius: '12px',
          fontFamily: 'Raleway',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px',
        },
        standardError: {
          background:'rgba(244, 82, 82, 0.2)',
          color: '#F45252',
          borderRadius: '12px',
          fontFamily: 'Raleway',
          fontStyle: 'normal',
          fontWeight: '600',
          lineHeight: '20px',
        },
      },
    }
  }
} as ThemeOptions);

export const ThemeContext = React.createContext(
  (themeName: string): void => {}
);

const ThemeProviderWrapper: React.FC = (props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const setThemeName = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    _setThemeName(themeName);
  };

  return (
    <ThemeProvider theme={theme}>
      <ThemeProvider theme={themes}>
        <StylesProvider injectFirst>
          <ThemeContext.Provider value={setThemeName}>
            {props.children}
          </ThemeContext.Provider>
        </StylesProvider>
      </ThemeProvider>
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
